import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import { AllMethodOfTesting } from "../../../../../features/admin/common/Slice";

const Common_Form = ({
  handleClose,
  showError,
  onSubmit,
  defaultValues,
  success,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  // console.log("showErrorshowError",showError)
  const dispatch = useDispatch();

  // Set default values if editing
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const [imagePreview, setImagePreview] = useState(null);

  const documentSectionRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const all_method_of_testing = useSelector(
    (state) => state.common.all_method_of_testing,
  );

  useEffect(() => {
    dispatch(AllMethodOfTesting());
  }, [dispatch]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="white_container" ref={documentSectionRef}>
        <div className="common_form_div">
          <div className="row">
            {/* Full Name */}
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label> Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" Name"
                  {...register("name", {
                    required: " Name is required",
                  })}
                />
                <Form.Text className="text-danger">
                  {errors?.name?.message}
                </Form.Text>
                {showError?.name && (
                  <Form.Text className="text-danger">
                    {showError?.name}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label> HNSC Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="HNSC Code"
                  {...register("hsn_code", {
                    required: "HNSC Code is required",
                  })}
                />
                <Form.Text className="text-danger">
                  {errors?.hsn_code?.message}
                </Form.Text>
                {showError?.hsn_code && (
                  <Form.Text className="text-danger">
                    {showError?.hsn_code}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label> Method Of Testing </Form.Label>

                <Controller
                  name="method_of_testing_id" // name of the field
                  {...register("method_of_testing_id", {
                    required: "Method of Testing is required",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.state_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={all_method_of_testing}
                    />
                  )}
                />

                {errors?.method_of_testing_id && (
                  <Form.Text className="text-danger">
                    {errors?.method_of_testing_id?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label>Price</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Price"
                  {...register("price", {
                    required: "Price is required",
                  })}
                  onKeyDown={(e) => {
                    // allow numbers
                    if (/[0-9]/.test(e.key)) return;

                    // allow one decimal point only
                    if (e.key === "." && !e.target.value.includes(".")) return;

                    // allow control keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ].includes(e.key)
                    )
                      return;

                    // block everything else
                    e.preventDefault();
                  }}
                />
                <Form.Text className="text-danger">
                  {errors?.price?.message}
                </Form.Text>
              </Form.Group>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="offcanvas_footer_holder">
          {!success ? (
            <div className="btns_holder">
              <Gray_Btn btnText="Cancel" onClick={handleClose} />
              <Black_Submit_Btn btnText="Submit" type="submit" />
              {/* <Refresh_btn /> */}
            </div>
          ) : (
            <Success_Toster successText="Data saved successfully!" />
          )}
        </div>
      </div>
    </Form>
  );
};

export default Common_Form;
